import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export default makeStyles((theme) => ({
  root: {
    "& div:last-child $body": {
      borderBottom: "none",
      width: "100%",
    },
  },
  item: {
    height: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: "var(--draggable-item-background, white)",
    borderRadius: theme.spacing(1),
  },
  body: {
    width: "100%",
    height: "100%",
  },
  cursor: {
    cursor: "move",
    width: 48,
    height: 48,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    "&:active svg": {
      color: grey[800],
    },

    "& svg": {
      color: grey[500],
      transition: "color .3s",
    },
  },
}));
